import { cn } from "@somethings-ui/core";
import { Scribbles } from "@somethings-ui/core/assets";

interface AiChatButtonProps {
  onClick: () => void;
  "aria-label": string;
  "aria-expanded"?: boolean;
  className?: string;
}

export function AiChatButton({
  onClick,
  className,
  "aria-label": ariaLabel,
  "aria-expanded": ariaExpanded,
}: AiChatButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      aria-expanded={ariaExpanded}
      className={cn(
        "flex size-14 shrink-0 items-center justify-center overflow-clip rounded-full border border-surfaces-z5 bg-white p-px shadow-lg transition-opacity hover:opacity-90 focus-visible:outline-none",
        className,
      )}
    >
      <img
        src={Scribbles.orangeLoops}
        alt=""
        aria-hidden
        className="size-10 object-contain"
      />
    </button>
  );
}
